(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      requestAnimationFrame(this.onScrollHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    mobileCatalogueChromeIsPersistent() {
      const persistent = window.matchMedia('(max-width: 989px)').matches &&
        !!document.querySelector('.pwbrandpage--image-hero');
      this.header.classList.toggle('pw-header--catalogue-mobile-persistent', persistent);
      return persistent;
    }
   

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // On phones and tablets the catalogue controls become the browsing
      // chrome. Keep the complete site header (including Shop by Colour) out
      // of the way at every non-zero scroll position; it returns only at the
      // genuine page top, not merely because the user changed direction.
      if (window.matchMedia('(max-width: 989px)').matches) {
        if (this.mobileCatalogueChromeIsPersistent()) {
          requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop <= 2) {
          requestAnimationFrame(this.reset.bind(this));
        } else if (!this.preventHide) {
          requestAnimationFrame(this.hide.bind(this));
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  function initialisePrewornDesktopHeaderCompaction(root = document) {
    const scope = root && typeof root.querySelector === 'function' ? root : document;
    const header = scope.matches?.('#shopify-section-header')
      ? scope
      : scope.querySelector('#shopify-section-header');
    if (!header || header.dataset.prewornCompactReady === 'true') return;

    const navigation = header.querySelector('#largenavcontainter');
    const imageTagHero = document.querySelector('.pwbrandpage--image-hero');
    const desktop = window.matchMedia('(min-width: 990px)');
    const collapseAfter = 24;
    const reopenDelay = 350;
    let animationFrame = 0;
    let reopenTimer = 0;

    const closeNavigation = () => {
      if (!navigation) return;
      navigation.classList.remove('is-department-open');
      navigation.querySelectorAll('[data-preworn-department]').forEach((item) => {
        item.classList.remove('is-active');
        item.querySelector('[aria-controls]')?.setAttribute('aria-expanded', 'false');
      });
      navigation.querySelectorAll('[data-preworn-panel]').forEach((panel) => {
        panel.classList.remove('active-menu', 'pw-active-menu');
        panel.setAttribute('aria-hidden', 'true');
      });
    };

    const setCollapsed = (collapsed) => {
      const shouldCollapse = desktop.matches && collapsed;
      header.classList.toggle('pw-header--nav-collapsed', shouldCollapse);
      header.dataset.pwDesktopHeaderState = shouldCollapse ? 'compact' : 'open';
      if (shouldCollapse) closeNavigation();
    };

    const clearReopenTimer = () => {
      window.clearTimeout(reopenTimer);
      reopenTimer = 0;
    };

    const imageTagHeroIsCollapsed = () => !!(
      imageTagHero && imageTagHero.classList.contains('is-tag-hero-collapsed')
    );

    const syncState = () => {
      animationFrame = 0;
      const scrollTop = Math.max(window.pageYOffset || 0, document.documentElement.scrollTop || 0);

      if (!desktop.matches) {
        clearReopenTimer();
        setCollapsed(false);
        return;
      }

      // Image-led catalogue pages deliberately realign the browse controls
      // after their hero closes. That layout correction can take scrollY back
      // to zero without the shopper asking to reopen anything. Keep the
      // department row compact for as long as the hero itself is collapsed;
      // the hero's genuine top-return rule remains the single source of truth.
      if (imageTagHeroIsCollapsed()) {
        clearReopenTimer();
        setCollapsed(true);
        return;
      }

      if (scrollTop > collapseAfter) {
        clearReopenTimer();
        const navigationIsEngaged = navigation && (
          navigation.classList.contains('is-department-open') ||
          navigation.contains(document.activeElement)
        );
        if (!navigationIsEngaged) setCollapsed(true);
        return;
      }

      if (!header.classList.contains('pw-header--nav-collapsed')) {
        setCollapsed(false);
        return;
      }

      clearReopenTimer();
      reopenTimer = window.setTimeout(() => {
        const latestScrollTop = Math.max(window.pageYOffset || 0, document.documentElement.scrollTop || 0);
        if (desktop.matches && latestScrollTop <= collapseAfter) setCollapsed(false);
      }, reopenDelay);
    };

    const queueSync = () => {
      if (animationFrame) return;
      animationFrame = window.requestAnimationFrame(syncState);
    };

    window.addEventListener('scroll', queueSync, { passive: true });
    if (typeof desktop.addEventListener === 'function') desktop.addEventListener('change', queueSync);
    else desktop.addListener(queueSync);
    navigation?.addEventListener('mouseleave', queueSync);
    navigation?.addEventListener('focusout', queueSync);
    if (imageTagHero && typeof window.MutationObserver === 'function') {
      const heroStateObserver = new window.MutationObserver(queueSync);
      heroStateObserver.observe(imageTagHero, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    header.dataset.prewornCompactReady = 'true';
    syncState();
  }

  function initialisePrewornHeaderNavigation(root = document) {
    const largeNav = root.querySelector('#largenavcontainter');
    if (!largeNav || largeNav.dataset.prewornReady === 'true') return;

    const departments = Array.from(
      largeNav.querySelectorAll('[data-preworn-department]')
    );
    const panels = Array.from(
      largeNav.querySelectorAll('[data-preworn-panel]')
    );
    const directDepartments = Array.from(
      largeNav.querySelectorAll('.pw-department--direct')
    );
    const headerSurface = largeNav.closest('.header-wrapper') || largeNav;
    const desktop = window.matchMedia('(min-width: 990px)');

    const closeNavigation = () => {
      largeNav.classList.remove('is-department-open');
      departments.forEach((item) => {
        item.classList.remove('is-active');
        item.querySelector('[aria-controls]')?.setAttribute('aria-expanded', 'false');
      });
      panels.forEach((panel) => {
        panel.classList.remove('active-menu', 'pw-active-menu');
        panel.setAttribute('aria-hidden', 'true');
      });
    };

    const activateDepartment = (item) => {
      if (!desktop.matches) return;

      const key = item.getAttribute('data-preworn-department');
      const panel = panels.find(
        (candidate) => candidate.getAttribute('data-preworn-panel') === key
      );

      if (!panel) {
        closeNavigation();
        return;
      }

      departments.forEach((candidate) => {
        candidate.classList.toggle('is-active', candidate === item);
        candidate
          .querySelector('[aria-controls]')
          ?.setAttribute('aria-expanded', candidate === item ? 'true' : 'false');
      });
      panels.forEach((candidate) => {
        candidate.classList.toggle('active-menu', candidate === panel);
        candidate.classList.toggle('pw-active-menu', candidate === panel);
        candidate.setAttribute('aria-hidden', candidate === panel ? 'false' : 'true');
      });
      largeNav.classList.add('is-department-open');
    };

    departments.forEach((item) => {
      item.addEventListener('mouseenter', () => activateDepartment(item));
      item.addEventListener('focusin', () => activateDepartment(item));
    });

    directDepartments.forEach((item) => {
      item.addEventListener('mouseenter', closeNavigation);
      item.addEventListener('focusin', closeNavigation);
    });

    largeNav.addEventListener('mouseleave', closeNavigation);
    largeNav.addEventListener('focusout', (event) => {
      if (!largeNav.contains(event.relatedTarget)) closeNavigation();
    });

    document.addEventListener('pointerdown', (event) => {
      if (!headerSurface.contains(event.target)) closeNavigation();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeNavigation();
    });

    desktop.addEventListener('change', (event) => {
      if (!event.matches) closeNavigation();
    });

    largeNav.dataset.prewornReady = 'true';
    closeNavigation();
  }

  function initialisePrewornMobileHeader(root = document) {
    const scope = root && typeof root.querySelector === 'function' ? root : document;
    const menuButton = scope.querySelector('.pw-mobile-menu-button');
    const menuDetails = scope.querySelector('#Details-menu-drawer-container');
    const searchButton = scope.querySelector('#search-icon-bubble');
    const searchPanel = scope.querySelector('#PrewornMobileSearchPanel');
    const sectionHeader = document.getElementById('shopify-section-header');
    const mobileViewport = window.matchMedia('(max-width: 989px)');
    const catalogueHero = document.querySelector('.pwbrandpage--image-hero');
    const catalogueContextIsActive = () => !!catalogueHero;
    const catalogueHeroIsCollapsed = () => !!(
      catalogueHero && catalogueHero.classList.contains('is-tag-hero-collapsed')
    );
    const catalogueSearchIsReady = () => !!(
      searchPanel && searchPanel.querySelector('[data-pw-global-search="true"]')
    );
    const mobileCatalogueChromeIsPersistent = () => mobileViewport.matches &&
      catalogueContextIsActive();

    const disableLegacyBuddhaMobileMenu = () => {
      const menuList = menuDetails?.querySelector('.pw-mobile-menu-list');
      if (!menuList) return;

      const restoreThemeMenu = () => {
        Array.from(menuList.children).forEach((item) => {
          if (item.classList.contains('buddha-menu-item')) {
            item.remove();
            return;
          }

          item.classList.remove('buddha-disabled');
        });

        menuList.classList.remove('horizontal-mega-menu', 'vertical-mega-menu');
      };

      if (menuList.dataset.prewornBuddhaGuard !== 'true') {
        let restoreQueued = false;
        const legacyMenuObserver = new MutationObserver(() => {
          if (restoreQueued) return;
          restoreQueued = true;
          window.requestAnimationFrame(() => {
            restoreQueued = false;
            restoreThemeMenu();
          });
        });

        legacyMenuObserver.observe(menuList, {
          childList: true,
          attributes: true,
          attributeFilter: ['class'],
          subtree: true
        });
        menuList.dataset.prewornBuddhaGuard = 'true';
      }

      restoreThemeMenu();
      window.setTimeout(restoreThemeMenu, 0);
      window.setTimeout(restoreThemeMenu, 500);
    };

    disableLegacyBuddhaMobileMenu();

    const setSearchOpen = (open, focusInput = true) => {
      if (!searchButton || !searchPanel) return;
      searchPanel.hidden = !open;
      searchButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && focusInput) {
        window.setTimeout(() => searchPanel.querySelector('input[type="search"]')?.focus(), 0);
      }
    };

    if (menuButton && menuDetails && menuButton.dataset.prewornReady !== 'true') {
      const nativeSummary = menuDetails.querySelector(':scope > summary');
      const syncMenuState = () => {
        const open = menuDetails.hasAttribute('open');
        menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        if (open) menuDetails.classList.add('menu-opening');
        else menuDetails.classList.remove('menu-opening');
        if (sectionHeader) {
          sectionHeader.classList.toggle('pw-header--mobile-menu-open', open);
        }
        if (!open && mobileCatalogueChromeIsPersistent()) {
          setSearchOpen(catalogueHeroIsCollapsed() && catalogueSearchIsReady(), false);
        }
      };

      menuButton.addEventListener('click', () => {
        setSearchOpen(false);
        if (nativeSummary) {
          nativeSummary.click();
        } else if (menuDetails.hasAttribute('open')) {
          menuDetails.removeAttribute('open');
        } else {
          menuDetails.setAttribute('open', '');
        }
        window.requestAnimationFrame(syncMenuState);
      });

      menuDetails.addEventListener('toggle', syncMenuState);
      menuButton.dataset.prewornReady = 'true';
      syncMenuState();
    }

    if (searchButton && searchPanel && searchButton.dataset.prewornReady !== 'true') {
      searchButton.addEventListener('click', (event) => {
        event.preventDefault();
        if (mobileCatalogueChromeIsPersistent()) {
          const canOpenCatalogueSearch = catalogueHeroIsCollapsed() && catalogueSearchIsReady();
          setSearchOpen(canOpenCatalogueSearch, canOpenCatalogueSearch);
          return;
        }
        const shouldOpen = searchPanel.hidden;
        if (shouldOpen && menuDetails?.hasAttribute('open')) {
          menuDetails.querySelector(':scope > summary')?.click();
        }
        setSearchOpen(shouldOpen);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        setSearchOpen(
          mobileCatalogueChromeIsPersistent() && catalogueHeroIsCollapsed() &&
            catalogueSearchIsReady(),
          false
        );
        if (menuDetails?.hasAttribute('open')) {
          menuDetails.querySelector(':scope > summary')?.click();
        }
      });

      const syncMobileCatalogueChrome = () => {
        const catalogueContext = catalogueContextIsActive();
        const persistent = mobileCatalogueChromeIsPersistent();
        const collapsed = catalogueContext && catalogueHeroIsCollapsed();
        sectionHeader?.classList.toggle('pw-header--catalogue-context', catalogueContext);
        sectionHeader?.classList.toggle('pw-header--catalogue-search-collapsed', collapsed);
        sectionHeader?.classList.toggle('pw-header--catalogue-mobile-persistent', persistent);
        setSearchOpen(persistent && collapsed && catalogueSearchIsReady(), false);
      };

      if (catalogueHero && typeof MutationObserver === 'function') {
        const catalogueHeroObserver = new MutationObserver(syncMobileCatalogueChrome);
        catalogueHeroObserver.observe(catalogueHero, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      if (typeof mobileViewport.addEventListener === 'function') {
        mobileViewport.addEventListener('change', syncMobileCatalogueChrome);
      } else if (typeof mobileViewport.addListener === 'function') {
        mobileViewport.addListener(syncMobileCatalogueChrome);
      }

      searchButton.dataset.prewornReady = 'true';
      syncMobileCatalogueChrome();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialisePrewornHeaderNavigation();
      initialisePrewornMobileHeader();
      initialisePrewornDesktopHeaderCompaction();
    });
  } else {
    initialisePrewornHeaderNavigation();
    initialisePrewornMobileHeader();
    initialisePrewornDesktopHeaderCompaction();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialisePrewornHeaderNavigation(event.target);
    initialisePrewornMobileHeader(event.target);
    initialisePrewornDesktopHeaderCompaction(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
